import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faDatabase,
  faPenNib,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../monogramma.png";
import { Navigate, useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { Button, Grid, Typography, Box } from "@mui/material";
import "../assets/css/header.css";

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // let access_token = Cookies.get("access_token");
  const access_token = localStorage.getItem("token");

  const [data, setData] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loc, setLoc] = useState(location.pathname);

  useEffect(() => {
    setLoc(location.pathname);
  }, [location.pathname]);

  let endpoint = process.env.REACT_APP_ENPOINT + "is-user-logged";

  let auth = false;

  const logout = (e) => {
    e.preventDefault();

    const endpoint = process.env.REACT_APP_ENPOINT + "logout";

    axios({
      method: "post",
      url: endpoint,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + access_token,
      },
      transformRequest: (data, error) => {},
    })
      .then((res) => {
        if (res.data === "logout") {
          localStorage.clear();

          window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
        }
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  const isUserLogged = async () => {
    //e.preventDefault();
    const response = await fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();

    if (result === "auth") {
      setIsLoggedIn(true);
    } else {
      if (loc !== "/login")
        window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
    }
    return result;
  };

  useEffect(() => {
    const MINUTE_MS = 300000;
    const interval = setInterval(() => {
      isUserLogged();
    }, MINUTE_MS);
    isUserLogged();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    const currentPath = location.pathname;

    if (
      currentPath === "/signing-completed" ||
      currentPath === "/signing-pending"
    ) {
      logout(e);
    } else {
      navigate(-1);
    }
  };

  if (isLoggedIn) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 999,
          paddingBottom: "500px !important",
        }}
      >
        <Grid
          container
          item
          xs={12}
          className="bg-blue-dark"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "5px 0px",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={2}
            md={1}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="logo-lexia-header" />
          </Grid>

          <Grid
            item
            xs={8}
            md={10}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography className="color-light title-header">
              LEXIA Sign
            </Typography>
          </Grid>

          <Grid
            item
            xs={2}
            md={1}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              onClick={handleClick}
              className="icon-logout container-icon"
              aria-label="Logout"
            ></div>
          </Grid>
        </Grid>
        {!loc.includes("paperwork") && !loc.includes("new-signing") && (
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#A2BDCB",
              padding: "10px 0px",
              height: "80px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              item
              xs={11.3}
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flexDirection: "row",
                flexWrap: "nowrap",
                textAlign: "center",
              }}
            >
              {loc !== "/new-signing" && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 4,
                    flex: 1,
                  }}
                >
                  {loc == "/signing-completed" && (
                    <Link
                      to="/signing-pending"
                      style={{
                        color: loc === "/signing-pending" ? "#bc2957" : "#1b2838",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Box
                        component="img"
                        src="/images/next.png"
                        alt="Icona"
                        sx={{
                          width: { xs: 12, sm: 12, md: 12 }, // cambia in base al breakpoint
                          height: "12px", // mantiene il rapporto originale
                          mr: 1,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: { xs: "14px", sm: "16px", md: "18px" },
                          fontWeight: 500,
                        }}
                      >
                        Passa ai Signing in corso
                      </Typography>
                    </Link>
                  )}

                  {loc == "/signing-pending" && (
                    <Link
                      to="/signing-completed"
                      style={{
                        color: loc === "/signing-completed" ? "#bc2957" : "#1b2838",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Box
                        component="img"
                        src="/images/next.png"
                        alt="Icona"
                        sx={{
                          width: { xs: 12, sm: 12, md: 12 }, // cambia in base al breakpoint
                          height: "12px", // mantiene il rapporto originale
                          mr: 1,
                        }}
                      />

                      <Typography
                        sx={{
                          fontSize: { xs: "14px", sm: "16px", md: "18px" },
                          fontWeight: 500,
                        }}
                      >
                        Passa ai Signing chiusi
                      </Typography>
                    </Link>
                  )}
                </Grid>
              )}

              {loc !== "/new-signing" && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "flex-end", md: "flex-end" },
                    flex: 1,
                  }}
                >
                  <Link to="/new-signing">
                    <Button
                      variant="outlined"
                      className="button-bg-purple"
                      sx={{
                        width: {
                          xs: "100px !important",
                          sm: "160px !important",
                        },
                        border: "none !important",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Typography
                        className="color-light"
                        sx={{
                          textTransform: "initial",
                          fontSize: { xs: "14px", sm: "16px", md: "18px" },
                          fontWeight: 500,
                        }}
                      >
                        Nuovo signing
                      </Typography>
                    </Button>
                  </Link>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </div>
    );
  } else {
    return null;
  }
};
export default Navigation;